import { addons } from "@storybook/addons";
import ElementTheme from "./ElementTheme";

addons.setConfig({
  theme: ElementTheme,
});
